import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const HomeWithPv: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m215 145h30v95h-30z' />
    <path d='m118.78 240.23-17.56-24.32 208.43-150.51c13.43-9.7 32.18-6.67 41.88 6.76s-232.75 168.07-232.75 168.07z' />
    <path d='m660 660h-540.43v-357.67l239.29-172.78c18.71-12.8 42.88-12.8 61.59-.02l.31.22 239.24 172.57zm-510.43-30h480.43v-312.32l-226.62-163.47c-8.36-5.63-19.09-5.63-27.44 0l-226.37 163.46z' />
  </IconBase>
));

HomeWithPv.displayName = 'HomeWithPv';

export default HomeWithPv;
